import { isPositiveNumber } from "et3-type-guards";
import React from "react";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import SignInError from "./IncorrectPasswordAlert";
import PasswordFormItem from "./PasswordFormItem";
import SignInButton from "./SignInButton";
import UsernameFormItem from "./UsernameFormItem";
import Welcome from "./Welcome";
import ET3PageDiv from "../../core/et3-page-div";
import ET3Div from "../../core/et3-div";
import Et3Image from "../../core/et3-Image";
import i18n from "../../constants/i18n";

const Login = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  React.useEffect(() => {
    getCoreHistoryStore().setPageName("CORE_LOGIN", "CORE_LOGIN");
  }, []);
  const userData = getCorePersonalStore().user.get();
  const showLoginPage = !isPositiveNumber(userData.id);

  return showLoginPage ? (
    <ET3PageDiv
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1920}
        height={1080}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="center"
        justifyContent="center"
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={1920}
          height={500}
          fDirection={"column"}
          color={colors.all.transparent}
          style={{}}
          alignItems="center"
          justifyContent="space-between"
          onClick={() => {}}
        >
          <Et3Image
            type="LOCAL"
            alt={i18n.get("ALKHATTABA_ADMIN")}
            imageName={"et3-logo"}
            size={500}
            onClick={() => {}}
            style={{}}
          />
          <SignInError />
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={1920}
            height={200}
            fDirection={"column"}
            color={colors.all.transparent}
            style={{}}
            alignItems="center"
            justifyContent="center"
            onClick={() => {}}
          >
            <UsernameFormItem />
            <PasswordFormItem />
          </ET3Div>
          <SignInButton />
        </ET3Div>
      </ET3Div>
    </ET3PageDiv>
  ) : (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Welcome />
    </ET3PageDiv>
  );
});
export default Login;
